import { Component, input, output, model, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerModule } from 'primeng/drawer';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-shared-filter-drawer',
    standalone: true,
    imports: [CommonModule, DrawerModule, TooltipModule],
    templateUrl: './filter-drawer.component.html',
    styleUrls: ['./filter-drawer.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class SharedFilterDrawerComponent {
    // Usar model() para two-way binding - soporta tanto [visible] como [(visible)]
    visible = model<boolean>(false);
    title = input<string>('Filtros Avanzados');
    subtitle = input<string>('Personaliza tu búsqueda');
    width = input<string>('420px'); // Default width from incidents.html
    disableApply = input<boolean>(false);
    disableClear = input<boolean>(false);

    // Outputs adicionales
    apply = output<void>();
    clear = output<void>();
    close = output<void>();

    onClose() {
        this.visible.set(false);
        this.close.emit();
    }

    /** Sincroniza el cierre del drawer (clic fuera, Escape) con el model y el padre. Necesario con zoneless. */
    onVisibleChange(value: boolean) {
        this.visible.set(value);
        if (!value) this.close.emit();
    }

    onApply() {
        this.apply.emit();
    }

    onClear() {
        this.clear.emit();
    }
}
